// TODO: Delete this later. Not required.
export const contentLocations = [];
